import { IDashExtSiteSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../../../../httpClient/serverApi/requests/Request';

export interface IGetDashExtSiteSettingsParams {
  // this is needed to support guest session in vizclient
  // should be empty if user is authenticated
  path: string;
}

export type IGetDashExtSiteSettingsResult = IResult & IDashExtSiteSettings;

export class GetDashExtSiteSettingsRequest extends Request<IGetDashExtSiteSettingsParams, IGetDashExtSiteSettingsResult> {
  constructor(params: IGetDashExtSiteSettingsParams) {
    super('getExtensionsSiteSettings', params);
  }
}
